import React from 'react';
import './FilterNodes.css';

export function FilterNodes(props) {
  const { 
      nodes, 
      selectEntityNode, 
      selectNetworkName, 
      selectStatus, 
      handleSelectEntity ,
      handleSelectNetworkName, 
      handleSelectStatus } = props;

  return (
    <>
    <div className='select-filter-nodes'>
      <label>Entity</label>
      <input
        value={selectEntityNode}
        className='select-filter-nodes__entity' 
        placeholder='Entity name'
        onChange={handleSelectEntity}
      />

      <label>Network Name</label>
        <select 
          className='select-filter-nodes__networkName' 
          onChange={handleSelectNetworkName}
          value={selectNetworkName}
        >
          <option >Select</option>
          <option value="Mainnet">Mainnet</option>
          <option value="Open-Protest">Open-Protest</option>
          <option value="Pro-Testnet">Pro-Testnet</option>
          <option value="Pro-Testnet RBB">Pro-Testnet RBB</option>
      </select>

      <label>Status</label>
        <select
          value={selectStatus} 
          className='select-filter-nodes__status' 
          onChange={handleSelectStatus}
        >
          <option >Select</option>
          <option value="CREATED">CREATED</option>
          <option value="DELETED">DELETED</option>
          <option value="APPROVED">APPROVED</option>
          <option value="ACTIVE">ACTIVE</option>
      </select>
    </div>
    </>
  )
}
